// extracted by mini-css-extract-plugin
module.exports = {"navSpan":"styles_navSpan__at0oN","navLink":"styles_navLink__U_Dqb"};